module.exports = __webpack_public_path__ + "img/3-simple-ways-to-grow-your-chiropractor-business-online.62e07f78.jpg";